module.exports = __webpack_public_path__ + "img/cob.a0fc5195.svg";